export const LANGUAGE_KEY = 'sav-language'

export const LANGUAGES = {
  EN_US: 'en-US',
  FR_CA: 'fr-CA',
}

export enum COUNTRY_CODES {
  USA = 'US',
  Canada = 'CA',
}

export const STRIPE_PK = process.env.REACT_APP_STRIPE_PK
export const SCS_AGENT = process.env.REACT_APP_SCS_AGENT
export const SCS_CHANNEL = process.env.REACT_APP_SCS_CHANNEL

export const LANG_OPTIONS = [
  { id: LANGUAGES.EN_US, label: 'english' },
  { id: LANGUAGES.FR_CA, label: 'french' },
]

const EDGE_API_URL_SUFFIX = `/edge/api`
const EDGE_CONFIG_URL_SUFFIX = `/config`
const EDGE_SOFTWARE_URL_SUFFIX = `/software`
const EDGE_PROFILES_URL_SUFFIX = `/profiles`

const EDGE_API_BASE_URL = process.env.REACT_APP_EDGE_API_BASE_URL
export const BILLING_API_URL = process.env.REACT_APP_BILLING_API_URL
export const NETWORK_API_URL = process.env.REACT_APP_NETWORK_API_URL
export const NETWORK_API_KEY = process.env.REACT_APP_NETWORK_API_KEY
export const MIST_CLOUD_URL = process.env.REACT_APP_MIST_CLOUD_URL
export const LICENSES_STORE_URL = process.env.REACT_APP_LICENSES_STORE_URL
export const ENV = process.env.REACT_APP_ENV

export const BASE_URL = EDGE_API_BASE_URL

export const EDGE_API_URL = `${EDGE_API_BASE_URL}${EDGE_API_URL_SUFFIX}`
export const EDGE_CONFIG_URL = `${EDGE_API_BASE_URL}${EDGE_CONFIG_URL_SUFFIX}`
export const EDGE_SOFTWARE_URL = `${EDGE_API_BASE_URL}${EDGE_SOFTWARE_URL_SUFFIX}`
export const EDGE_PROFILES_URL = `${EDGE_API_BASE_URL}${EDGE_PROFILES_URL_SUFFIX}`

export const TERMS_AND_CONDITIONS_LINK =
  'https://savant.com/business-subscription-terms'

export const JUNIPER_TERMS_AND_CONDITIONS_LINK =
  'https://www.juniper.net/documentation/en_US/release-independent/licenses/agreements/eula-generic-en.pdf'

export const GOOGLE_MAPS_GEOCODING_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_GEOCODING_KEY || ''
export const GOOGLE_MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY || ''

export const PERMISSIONS_POLLING_INTERVAL = parseInt(
  process.env.REACT_APP_PERMISSIONS_POLLING_INTERVAL || '30000',
  10
)

export const DOMAIN_NAME_REGEXP = /^[\w-_.' ]+$/

export const DASH_SYMBOL = '-'
